import { PhotoAvatar, Text, cn } from '@growtherapy/sprout-ui';

import { Provider } from '../types';

export type ProviderAvatarProps = {
  className?: string;
  provider: Pick<Provider, 'image' | 'name' | 'pronouns'>;
};

export function ProviderAvatar({ className, provider }: ProviderAvatarProps) {
  return (
    <div
      className={cn('flex items-center gap-x-3 fs-exclude', className)}
      data-dd-privacy='mask'
      data-testid='provider-avatar'
    >
      <PhotoAvatar
        containerClassName='bg-neutral-100'
        alt={`Provider ${provider.name}`}
        src={provider?.image ?? ''}
        size='md'
      />
      <Text
        variant='lg'
        className='font-medium text-neutral-100 rebrand:text-text-inverse'
        data-dd-action-name='Click on provider avatar'
      >
        {provider.name}
        {(provider?.pronouns?.length ?? 0) > 0 && (
          <span className='font-normal rebrand:text-text-inverse'>({provider.pronouns![0]})</span>
        )}
      </Text>
    </div>
  );
}
